import { ACTION_TYPES, MUTATION_TYPES } from './types';
export default {
  async [ACTION_TYPES.RESET](context) {
    context.commit(MUTATION_TYPES.RESET);
  },
};
